import { RX } from '../../../constants/rx';
import { CREATE_MANHEIM_ACCOUNT } from '../../../constants/resources';
import { VALIDATION_ERROR_MESSAGES } from '../../../../../shared/js/constants';
import { getCreateNewAccountFormValidations } from './validations';
import { parsePhone } from '../../../../../shared/js/util/validationUtils';

const { flex } = window;
const {
    React,
    ReactAddons: { PropTypes },
    Formsy
} = flex.lib;
const { SpinnerModal } = flex.components.Modals;

const {
    FormsyPrismInput,
    PrismButton,
    PrismLabel,
    PrismIcon
} = flex.components;

class CreateAccountForm extends React.PureComponent {
    static propTypes = {
        registrationToken: PropTypes.string.isRequired,
        firstName: PropTypes.string.isRequired,
        lastName: PropTypes.string.isRequired,
        email: PropTypes.string.isRequired,
        userName: PropTypes.string,
        password: PropTypes.string,
        phone: PropTypes.string,
        hasActiveFlexAccount: PropTypes.bool,
        isBusy: PropTypes.bool,
        isFormEditable: PropTypes.bool,
        userCreationErrors: PropTypes.array
    };

    static defaultProps = {
        isBusy: false,
        isFormEditable: true
    };

    state = {
        isFormValid: false,
        isPasswordVisible: false,
        isConfirmPasswordVisible: false
    };

    onSubmit = (model) => {
        const { firstName, lastName, username, password, phone, email } = model;
        const { registrationToken } = this.props;

        const parsedPhone = parsePhone(phone);

        if (parsedPhone) {
          flex.trigger(
            RX.CREATE_NEW_ACCOUNT.SUBMIT,
            registrationToken,
            firstName,
            lastName,
            username,
            password,
            parsedPhone,
            email
          );
        }
    };

    onValid = () => {
        this.setState({
            isFormValid: true
        });
    };

    onInvalid = () => {
        this.setState({
            isFormValid: false
        });
    };

    onCancelClick = () => {
        flex.trigger(RX.CREATE_NEW_ACCOUNT.CANCEL, this.props.registrationToken);
    };

    onShowPasswordClick = () => {
        this.setState({ isPasswordVisible: !this.state.isPasswordVisible });
    };

    onShowConfirmPasswordClick = () => {
        this.setState({ isConfirmPasswordVisible: !this.state.isConfirmPasswordVisible });
    };

    onUsernameChange = () => {
        flex.trigger(
            RX.CREATE_NEW_ACCOUNT.REMOVE_USERNAME_VALIDATION_ERROR,
            this.props.userCreationErrors
        );
    };

    onPhoneChange = () => {
        flex.trigger(
            RX.CREATE_NEW_ACCOUNT.REMOVE_PHONE_VALIDATION_ERROR,
            this.props.userCreationErrors
        );
    };

    renderActionButtons = (isBusy, isFormEditable) => {
        const isSubmitDisabled = !this.state.isFormValid || isBusy || !isFormEditable;
        const isCancelDisabled = isBusy || !isFormEditable;

        return (
            <div className="create-account-form__buttons-container">
                <PrismButton
                    className="create-account-form__button"
                    type="button"
                    onClick={this.onCancelClick}
                    disabled={isCancelDisabled}
                    actionLink
                >
                    {CREATE_MANHEIM_ACCOUNT.FORM_CANCEL_BTN}
                </PrismButton>
                <PrismButton
                    className="create-account-form__button"
                    disabled={isSubmitDisabled}
                >
                    {CREATE_MANHEIM_ACCOUNT.FORM_SUBMIT_BTN}
                </PrismButton>
                {isBusy && <SpinnerModal message='User Registration in Process' />}
            </div>
        );
    };

    getPasswordLabel = (label, isVisible, onClick) => {
        const glyph = !isVisible ? 'eye' : 'eye-blocked';
        const title = !isVisible
            ? CREATE_MANHEIM_ACCOUNT.SHOW_PASSWORD_ICON_TITLE
            : CREATE_MANHEIM_ACCOUNT.HIDE_PASSWORD_ICON_TITLE;

        const formattedTitle = flex.formatString(title, label);

        return (
            <PrismLabel labelClassName="create-account-form__password-label" >
                {label} *
                <PrismIcon glyph={glyph} onClick={onClick} title={formattedTitle} />
            </PrismLabel>
        );
    };

    render() {
        const {
            isBusy,
            isFormEditable,
            firstName,
            lastName,
            userName,
            phone,
            password,
            email,
            hasActiveFlexAccount,
            userCreationErrors
        } = this.props;
        const { isPasswordVisible, isConfirmPasswordVisible } = this.state;

        const isFormDisabled = isBusy || !isFormEditable;

        const {
            emailValidation,
            usernameValidation,
            passwordValidation,
            firstNameValidation,
            lastNameValidation,
            phoneValidation
        } = getCreateNewAccountFormValidations();

        const passwordLabel = this.getPasswordLabel(
            CREATE_MANHEIM_ACCOUNT.PASSWORD_FIELD_LBL,
            isPasswordVisible,
            this.onShowPasswordClick
        );
        const confirmPasswordLabel = this.getPasswordLabel(
            CREATE_MANHEIM_ACCOUNT.CONFIRM_PASSWORD_FIELD_LBL,
            isConfirmPasswordVisible,
            this.onShowConfirmPasswordClick
        );

        const passwordInputType = !isPasswordVisible ? 'password' : 'text';
        const confirmPasswordInputType = !isConfirmPasswordVisible ? 'password' : 'text';

        return (
            <Formsy.Form
                className="create-account-form"
                onValidSubmit={this.onSubmit}
                onValid={this.onValid}
                onInvalid={this.onInvalid}
                autoComplete="off"
            >
                <FormsyPrismInput 
                    type="hidden"
                    id="userCreationErrors"
                    name="userCreationErrors"
                    value={userCreationErrors}
                />
                <FormsyPrismInput
                    label={CREATE_MANHEIM_ACCOUNT.FIRST_NAME_FIELD_LBL}
                    type="text"
                    placeholder={CREATE_MANHEIM_ACCOUNT.FIRST_NAME_FIELD_PLACEHOLDER}
                    id="firstName"
                    name="firstName"
                    value={firstName}
                    disabled={isFormDisabled || hasActiveFlexAccount}
                    validations={firstNameValidation.validations}
                    validationErrors={firstNameValidation.validationErrors}
                    validationError={VALIDATION_ERROR_MESSAGES.REQUIRED(CREATE_MANHEIM_ACCOUNT.FIRST_NAME_FIELD)}
                    required
                />
                <FormsyPrismInput
                    label={CREATE_MANHEIM_ACCOUNT.LAST_NAME_FIELD_LBL}
                    type="text"
                    placeholder={CREATE_MANHEIM_ACCOUNT.LAST_NAME_FIELD_PLACEHOLDER}
                    id="lastName"
                    name="lastName"
                    value={lastName}
                    disabled={isFormDisabled || hasActiveFlexAccount}
                    validations={lastNameValidation.validations}
                    validationErrors={lastNameValidation.validationErrors}
                    validationError={VALIDATION_ERROR_MESSAGES.REQUIRED(CREATE_MANHEIM_ACCOUNT.LAST_NAME_FIELD)}
                    required
                />
                <FormsyPrismInput
                    label={CREATE_MANHEIM_ACCOUNT.USERNAME_FIELD_LBL}
                    type="text"
                    placeholder={CREATE_MANHEIM_ACCOUNT.USERNAME_FIELD_PLACEHOLDER}
                    id="username"
                    name="username"
                    value={userName}
                    onChange={this.onUsernameChange}
                    disabled={isFormDisabled || hasActiveFlexAccount}
                    validations={usernameValidation.validations}
                    validationErrors={usernameValidation.validationErrors}
                    validationError={VALIDATION_ERROR_MESSAGES.REQUIRED(CREATE_MANHEIM_ACCOUNT.USERNAME_FIELD)}
                    required
                />
                <FormsyPrismInput
                    label={passwordLabel}
                    type={passwordInputType}
                    placeholder={CREATE_MANHEIM_ACCOUNT.PASSWORD_FIELD_PLACEHOLDER}
                    id="password"
                    name="password"
                    value={password}
                    disabled={isFormDisabled}
                    autoComplete="new-password"
                    validations={passwordValidation.validations}
                    validationErrors={passwordValidation.validationErrors}
                    validationError={VALIDATION_ERROR_MESSAGES.REQUIRED(CREATE_MANHEIM_ACCOUNT.PASSWORD_FIELD)}
                    required
                />
                <FormsyPrismInput
                    label={confirmPasswordLabel}
                    type={confirmPasswordInputType}
                    placeholder={CREATE_MANHEIM_ACCOUNT.CONFIRM_PASSWORD_FIELD_PLACEHOLDER}
                    id="confirmPassword"
                    name="confirmPassword"
                    value={password}
                    disabled={isFormDisabled}
                    autoComplete="new-password"
                    validations="equalsField:password"
                    validationError="Passwords do not match"
                    required
                />
                <FormsyPrismInput
                    label={CREATE_MANHEIM_ACCOUNT.PHONE_FIELD_LBL}
                    type="text"
                    placeholder={CREATE_MANHEIM_ACCOUNT.PHONE_FIELD_PLACEHOLDER}
                    id="phone"
                    name="phone"
                    value={phone}
                    onChange={this.onPhoneChange}
                    disabled={isFormDisabled}
                    validations={phoneValidation.validations}
                    validationErrors={phoneValidation.validationErrors}
                    validationError={VALIDATION_ERROR_MESSAGES.REQUIRED(CREATE_MANHEIM_ACCOUNT.PHONE_FIELD)}
                    required
                />
                <FormsyPrismInput
                    label={CREATE_MANHEIM_ACCOUNT.EMAIL_FIELD_LBL}
                    type="text"
                    placeholder={CREATE_MANHEIM_ACCOUNT.EMAIL_FIELD_PLACEHOLDER}
                    id="email"
                    name="email"
                    value={email}
                    disabled={true}
                    validations={emailValidation.validations}
                    validationError={VALIDATION_ERROR_MESSAGES.REQUIRED(CREATE_MANHEIM_ACCOUNT.EMAIL_FIELD)}
                    validationErrors={emailValidation.validationErrors}
                />
                {this.renderActionButtons(isBusy, isFormEditable)}
            </Formsy.Form>
        );
    }
}

export default CreateAccountForm;
